import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SalesmanForm = () => {
  const [fullname, setSalesmanName] = useState('');
  const [buttonvalue, setbuttonvalue] = useState("Create Salesman");
  

  const handleSubmit = async () => {
    if (!fullname) {
      toast.error('Please enter the salesman\'s name.');
    } else {
      try {
        setbuttonvalue("Creating")
        const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/salesman/add_salesman`, {
          fullname: fullname,
        });
        if (response.status === 200) {
          toast.success('Salesman created successfully!');
          // Clear the input field after successful submission
          setSalesmanName('');
          setbuttonvalue("Create Salesman")
        }
      } catch (error) {
        console.log(error.message);
        toast.error('An error occurred while creating the salesman.');
      }
    }
  };

  return (
    <>
      <div className="main flex flex-col items-center justify-center">
        {/* Header with Tailwind CSS */}
        <h1 className="text-3xl font-semibold mb-6 text-green-800">Salesman Module</h1>

        <label htmlFor="fullname" className="text-lg mb-2">
          Enter your Salesman's name
        </label>
        <input
          type="text"
          name="fullname"
          id="fullname"
          placeholder="Salesman's name"
          autoComplete="off"
          value={fullname}
          onChange={(e) => setSalesmanName(e.target.value)}
          className="px-3 py-2 border w-full rounded-lg shadow-md focus:outline-none focus:ring focus:border-blue-300"
        />

        <button
          className="bg-green-800 text-white py-2 w-full flex justify-center rounded-md hover:bg-green-700"
          onClick={handleSubmit}
        >
          {buttonvalue}
        </button>

        {/* Toast notification container */}
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        
        <article className="md:grid grid-cols-2 gap-10"></article>
      </div>
    </>
  );
};

export default SalesmanForm;
